<template>
    <div id="faqs">
        <!--=====================================-->
        <!--=           Faq Area Start         =-->
        <!--=====================================-->
        <section class="section section-padding-equal bg-color-light-gray faq-area">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-xl-4">
                        <div class="section-heading heading-left">
                            <span class="subtitle bold primary">Preguntas Frecuentes</span>
                            <h2 class="bold">Planes de Inversión.</h2>                        
                        </div>
                    </div>
                    <div class="col-lg-7 col-xl-8">
                        <div class="faq-accordion">
                            <div class="accordion" id="accordion" data-sal="slide-up" data-sal-duration="800"
                                data-sal-delay="100">
                                <div class="accordion-item">
                                    <h6 class="accordion-header">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#faq1" aria-expanded="true" aria-controls="faq1">
                                            ¿Puedo cancelar o modificar mi Plan de Inversión?
                                        </button>
                                    </h6>
                                    <div id="faq1" class="accordion-collapse collapse" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <p>Puedes cancelar o modificar tu plan de inversión en cualquier momento.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h6 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#faq2" aria-expanded="false" aria-controls="faq2">
                                            ¿Si cancelo mi Plan de Inversión tendré mi capital invertido disponible al momento?
                                        </button>
                                    </h6>
                                    <div id="faq2" class="accordion-collapse collapse" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <p>No. Tus capital se encontrará prestado a distintos plazos. En caso de que requieras liquidez, podrás utilizar el mercado secundario del Campo de Girasoles para vender tu portafolio personal.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h6 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#faq3" aria-expanded="false" aria-controls="faq3">
                                            ¿Puedo seleccionar en qué proyectos se invertirá automáticamente el dinero?
                                        </button>
                                    </h6>
                                    <div id="faq3" class="accordion-collapse collapse" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <p>No. El algoritmo se encuentra diseñado para maximizar la diversificación y reducir el riesgo de tu portafolio. Todos los proyectos publicados cumplen con un estricto proceso de evaluacióny selección.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h6 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#faq4" aria-expanded="false" aria-controls="faq4">
                                            ¿En qué se colocará la inversión automática?
                                        </button>
                                    </h6>
                                    <div id="faq4" class="accordion-collapse collapse" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <ol class="list-style">
                                                <li>En primer lugar, los recursos se colocan en proyectos en fondeo.</li>
                                                <li>En segundo lugar, si no existen proyecto en fondeo, los recursos se colocarán para adquirir préstamos por medio del mercado secundario (exclusivo para los inversionistas que formen parte del Campo de Girasoles).</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--=====================================-->
        <!--=           Faq Area Start         =-->
        <!--=====================================-->
        <section class="section pb--90 bg-color-light-gray faq-area">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-xl-4">
                        <div class="section-heading heading-left">
                            <span class="subtitle bold primary">Preguntas Frecuentes</span>
                            <h2 class="bold">Abono recurrente.</h2>                        
                        </div>
                    </div>
                    <div class="col-lg-7 col-xl-8">
                        <div class="faq-accordion">
                            <div class="accordion" id="accordion-abono" data-sal="slide-up" data-sal-duration="800"
                                data-sal-delay="100">
                                <div class="accordion-item">
                                    <h6 class="accordion-header">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#faq1-a" aria-expanded="true" aria-controls="faq1-a">
                                            ¿Qué sucederá si el día que selección cae en día inhábil?
                                        </button>
                                    </h6>
                                    <div id="faq1-a" class="accordion-collapse collapse" data-bs-parent="#accordion-abono">
                                        <div class="accordion-body">
                                            <p>El intento de domiciliación se realizará al siguiente día hábil. Es decir, si el día seleccionado cae en sábado, se cobrará el lunes.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h6 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#faq2-a" aria-expanded="false" aria-controls="faq2-a">
                                            ¿Qué sucederá si al momento del intento de domiciliación mi cuenta de banco no tiene los fondos necesarios?
                                        </button>
                                    </h6>
                                    <div id="faq2-a" class="accordion-collapse collapse" data-bs-parent="#accordion-abono">
                                        <div class="accordion-body">
                                            <p>El intento fallará, lo volveremos a intentar durante los siguientes dos días hábiles. En caso de que la cuenta siga sin fondos, se repetirá el proceso hasta el siguiente mes.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h6 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#faq3-a" aria-expanded="false" aria-controls="faq3-a">
                                            ¿A qué cuenta de banco se puede domiciliar?
                                        </button>
                                    </h6>
                                    <div id="faq3-a" class="accordion-collapse collapse" data-bs-parent="#accordion-abono">
                                        <div class="accordion-body">
                                            <p>La domiciliación se tiene que realizar a una cuenta de banco que se encuentra a tu nombre. Para darla de alta es necesario que realices una transferencia SPEI desde ella.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data: () => ({
        drawer: true,
        drawerRight: true,
        right: null,
        left: null
    }),
    props: {
        source: String
    }
}
</script>